import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.auth/users/location-picker.htm";

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class LocationPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setLocationIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
	}

	templateUrl = () => `location-picker.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setLocationIds();
	}
	clearAll() {
		this.selected = {};
		this.setLocationIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(location) {
		return !!this.selected[location.id];
	}

	setLocationIds() {
		this.locationIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { locationIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(location) {
		const $ctrl = this;
		console.log("toggle", location.id, $ctrl.selected, location);

		if ($ctrl.single) {
			$ctrl.$close(location);
		} else if (location.id in $ctrl.selected) {
			delete $ctrl.selected[location.id];
			$ctrl.onLocationUnSelected &&
				$ctrl.onLocationUnSelected({ $location: location, ...$ctrl });
		} else {
			$ctrl.selected[location.id] = true;
			$ctrl.onLocationSelected &&
				$ctrl.onLocationSelected({ $location: location, ...$ctrl });
		}
		this.setLocationIds();
	}
	select(location) {
		const $ctrl = this;
		$ctrl.$close([location]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryRetailerShippingLocations.json?Status=Active",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"Name": "Name: A to Z",
				"-DisplayNameName": "Name: Z to A"
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Name,Id",
			autoLoad: true,
			append: false
		};
	}
}


